import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
  name: 'image',
})
export class ImagePipe implements PipeTransform {
  url: string = environment.apiURL;

  transform(value: unknown, ...args: unknown[]): string {
    const raw = String(value ?? '');
    // Pubbliche: URL diretto. type=accreditamento → usare appAuthSrc (Authorization + blob).
    const [pathPart, query = ''] = raw.split('?');
    const name = pathPart.split(/[\\/]/).pop() || '';
    const q = query ? `?${query}` : '';
    return `${this.url}image/${encodeURIComponent(name)}${q}`;
  }
}
